import { isEqualColors, tryParseColor } from '../color';
import { isHTMLOrSVGElement } from '../dom/node';
import {
  applyStyleToElement,
  applyStyleToRange,
  getInheritedStyleForNode,
  hasInheritedStyleForNode,
  removeStyleFromElement,
  removeStyleFromRange,
  StyleSpec,
} from '../dom/style';

const HIGHLIGHT_COLOR_SPEC: StyleSpec = {
  stylePropertyName: 'background-color',
  initialStylePropertyValue: 'transparent',
  mapValue: value => {
    // Validate the color and exclude "transparent".
    const color = tryParseColor(value);
    if (!color || color.alpha() < 1) {
      return '';
    }

    return value;
  },
  isValueEqual: isEqualColors,
};

export function nodeHasHighlightColor(node: Node, container: Node): boolean {
  return hasInheritedStyleForNode(container, node, HIGHLIGHT_COLOR_SPEC);
}

export function getHighlightColorForNode(node: Node, container: Node): string {
  return getInheritedStyleForNode(container, node, HIGHLIGHT_COLOR_SPEC);
}

export function removeHighlightColorFromElement(element: Element): Node | null {
  return isHTMLOrSVGElement(element) ? removeStyleFromElement(element, HIGHLIGHT_COLOR_SPEC) : element;
}

export function removeHighlightColorFromRange(container: Node, range: Range): Range {
  return removeStyleFromRange(container, range, HIGHLIGHT_COLOR_SPEC);
}

export function applyHighlightColorToElement(
  element: HTMLElement | SVGElement,
  highlightColor: string,
): void {
  applyStyleToElement(element, HIGHLIGHT_COLOR_SPEC, highlightColor);
}

export function setHighlightColorInRange(container: Node, range: Range, highlightColor: string): Range {
  return applyStyleToRange(container, range, HIGHLIGHT_COLOR_SPEC, highlightColor);
}
